import { Navigate } from 'react-router-dom'
import { useAuth } from '../auth/AuthContext'

export default function ProtectedRoute({ children, requireRole }) {
  const { user, loading } = useAuth()

  if (loading) {
    return <p className="max-w-md mx-auto px-4 py-10 text-slate-600">Loading…</p>
  }
  if (!user) return <Navigate to="/login" replace />

  if (requireRole) {
    const allowed = Array.isArray(requireRole) ? requireRole : [requireRole]
    if (!allowed.includes(user.role)) {
      return (
        <div className="max-w-md mx-auto px-4 py-10">
          <div className="card p-6 text-center">
            <h2 className="text-lg font-semibold text-slate-900">403 — Forbidden</h2>
            <p className="text-sm text-slate-600 mt-1">
              This page requires one of: <code className="text-xs">{allowed.join(', ')}</code>.
            </p>
          </div>
        </div>
      )
    }
  }
  return children
}
